import dayjs from 'dayjs';

export interface BadgeData {
  visitorType: string;
  visitorName: string;
  visitorCompany: string;
  hostLabel: string;
  hostName: string;
  orgName: string;
  visitDate: string;
}

export async function printBadge(badgeData: BadgeData): Promise<void> {
  try {
    
    const response = await fetch('/visitor-badge.html');
    if (!response.ok) {
      throw new Error('Failed to load badge template');
    }
    let templateHtml = await response.text();
    const normalizedVisitorType = (badgeData.visitorType || '').toLocaleUpperCase();

    templateHtml = templateHtml
      .replaceAll('VISITOR TYPE', normalizedVisitorType)
      .replaceAll('VISITOR FULL NAME', badgeData.visitorName)
      .replaceAll('Visitor Company', badgeData.visitorCompany)
      .replaceAll('HOST LABEL', badgeData.hostLabel)
      .replaceAll('HOST NAME', badgeData.hostName)
      .replaceAll('Org Name', badgeData.orgName)
      .replaceAll('YYYY-MM-DD', badgeData.visitDate);
    
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.setAttribute('title', 'Badge Print');
    document.body.appendChild(iframe);
    
    iframe.srcdoc = templateHtml;

    setTimeout(() => {
      
      iframe.contentWindow?.focus();
      
      setTimeout(() => {
        iframe.contentWindow?.print();
      }, 100);
      
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    }, 500);
    
  } catch (error) {
    console.error('Error printing badge:', error);
    throw error;
  }
}

export function formatVisitorName(firstName: string | null, middleName: string | null, lastName: string | null): string {
  const capitalizeFirst = (value: string) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) return '';
    return trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1);
  };

  const parts = [firstName, middleName, lastName]
    .filter(Boolean)
    .map((part) => capitalizeFirst(part as string))
    .filter(Boolean);

  return parts.join(' ') || 'Unknown Visitor';
}

export function formatVisitDate(dateString: string | null): string {
  if (!dateString) return new Date().toISOString().split('T')[0];
  try {
    return dayjs(dateString).format('YYYY-MM-DD');
  } catch {
    return new Date().toISOString().split('T')[0];
  }
}
